import React from 'react';
import './errorMessage.css';
import { imgUrlGenerate } from '../../helpers';

const ErrorMessage = () => (
  <div className="error-message-wrap">
    <img src={imgUrlGenerate(`error.jpg`)} alt='error' />
    <span className='error-message__text'>An error occured. <br /> Please refresh the page or come back later.</span>
  </div>
)

export default ErrorMessage